import type { Maybe } from '@custom/dx3';
import type { Scalars } from '../models/__generated__/graphql';
import { isValidDate } from './validators';

export const usNumberFormatter = new Intl.NumberFormat('en-US', {});
export const usDateFormatter = new Intl.DateTimeFormat('en-US');

// got from here
export function combineWithCommas(input: Array<string>) {
  if (input.length < 2) return input.join('');
  const last = input.pop();
  return input.join(', ') + ', and ' + last;
}

export function ISODateToDate(
  ISODate: Maybe<Scalars['ISODate']['input']> | null | Date
) {
  if (!ISODate) return null;
  const date = new Date(ISODate as unknown as string);
  if (isValidDate(date)) return date;
  return null;
}
